import React from "react";

const ThemeContext = React.createContext({
  collapsed: false,
});

export default ThemeContext;
